import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

import { DocumentService } from 'src/app/shared/document.service';
import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { DocumentTemplateSearchView } from './document-template-search.view';
import { DocumentTemplateListDataService } from 'src/app/general/document-templates/list/document-template-list.data';
import { DocumentTemplateCategorySummariesDataService } from 'src/app/general/document-template-categories/document-template-category.data';

interface DocumentTemplateSearchProps extends ComponentViewProps<number> {
	usage: DocumentGenerationUsage;
	marketId?: number;
	brandId?: number;
    mode: ControlMode;
	generateDocument: (targetId: number, usage: DocumentGenerationUsage, templateId: number, format: string, exportLanguage: string) => void;
}

@observer
export class DocumentTemplateSearchController extends React.Component<DocumentTemplateSearchProps, any> {
    @resolve
    documentService: DocumentService;

    @resolve
    toast: ToastNotifications;

    @observable
    dataService: DocumentTemplateListDataService;

    @observable
    templateCategoriesDataService: DocumentTemplateCategorySummariesDataService;

    @observable
    categories: DocumentTemplateCategorySummary[] = [];

    @observable
    categoryId: number;

    constructor(props) {
        super(props);
    }

    @autobind
    async templateCategoryQuery(): Promise<IDocumentTemplateCategorySummary[]> {
        this.templateCategoriesDataService.addSorting('id', 'asc');
        this.templateCategoriesDataService.pageSize = 25;
        let items = await this.templateCategoriesDataService.load(query => query);
        if (this.props.usage != null) {
            items = items.filter(x => x.usages.includes(this.props.usage));
        }
        return items;
    }

    @autobind
    private async filterData(categoryId: number): Promise<void> {
		if (categoryId == -1 || categoryId == -2) {
			this.dataService.removeFilter('categoryId');
			this.setParameters();
		} else if (categoryId > 0) {
			delete this.dataService.params.usages;
            this.dataService.addFilter('categoryId', 'eq', categoryId);
        }

        this.categoryId = categoryId;
        await this.dataService.reload();
    }

    @autobind
    private async loadData(): Promise<void> {
        const items = await this.templateCategoryQuery();
        this.categories.push({
            id: -1,
            displayName: 'ALL'
        });
        this.categories.push({
            id: -2,
            displayName: 'Favorites'
        });
        for (let cat of items) {
            this.categories.push({
                id: cat.id,
                displayName: cat.displayName
            });

        }
		this.categoryId = -1
		this.setParameters();
        this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.addSorting('id', 'asc', true);
        this.dataService.pageSize = 25;
        await this.dataService.load(query => query);
	}

	private setParameters() {
		this.dataService.params.usages = this.props.usage;
		if (this.props.marketId) {
			this.dataService.params.marketId = this.props.marketId;
		}
		if (this.props.brandId) {
			this.dataService.params.brandId = this.props.brandId;
		}
	}

    componentDidMount() {
        this.dataService = DocumentTemplateListDataService.make();
        this.templateCategoriesDataService = DocumentTemplateCategorySummariesDataService.make();
        this.props.setBusy(true);
        this.loadData()
            .catch((error) => {
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            })
            .then(() => {
                this.props.setBusy(false);
            });
    }

    render() {
        if (this.categoryId == null) {
            return null;
        }

        return (
            <DocumentTemplateSearchView
                model={this.dataService}
                setBusy={this.props.setBusy}
                generateDocument={this.props.generateDocument}
                categoryId={this.categoryId}
                filterData={this.filterData}
                usage={this.props.usage}
                mode={this.props.mode}
                idModel={this.props.model}
                categories={this.categories}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-search/document-template-search.controller.tsx